import React from 'react';
import { IconProps } from '.';

const SvgArrowIncrease = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path fill={color} fillRule='evenodd' d='M12 2 4 14.5h5.333V22h5.334v-7.5H20L12 2Z' clipRule='evenodd' />
    </svg>
  );
};

export default SvgArrowIncrease;
